import { history } from "../../src/index";

import * as types from '../constants/agendaitemdetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as agendaitemdetailsApi from '../api/agendaitemdetails';

export function resetAgendaItem() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_AGENDAITEM_RESET });
    }
}

export function setAgendaItemDetails(data) {
    // console.log("getAgendaItemDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_AGENDAITEM_REQUEST_COMPLETED, data: data });
    }
}

export function getAgendaItemDetails(ID) {
    // console.log("getAgendaItemDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_AGENDAITEM_REQUEST });
        agendaitemdetailsApi.getAgendaItem(ID)
            .then(function (response) {
                // console.log("getAgendaItemDetails", response)
                dispatch({ type: types.FETCH_AGENDAITEM_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getAgendaItemDetails Error", err)
                dispatch({ type: types.FETCH_AGENDAITEM_REQUEST_ERROR });
            });
    }
}

export function getAgendaItemDetailsList(committee_id) {
    // console.log("getAgendaItemDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_AGENDAITEM_LIST_REQUEST });
        agendaitemdetailsApi.getAgendaItemList(committee_id)
            .then(function (response) {
                // console.log("getAgendaItemDetailsList", response)
                dispatch({ type: types.FETCH_AGENDAITEM_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getAgendaItemDetailsList Error", err)
                dispatch({ type: types.FETCH_AGENDAITEM_LIST_REQUEST_ERROR });
            });
    }
}

export function addAgendaItemDetails(objModel) {
    // console.log("addAgendaItemDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_AGENDAITEM_REQUEST });
        agendaitemdetailsApi.addAgendaItem(objModel)
            .then(function (response) {
                // console.log("addAgendaItemDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_AGENDAITEM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/agenda/agenda-item-list/' + objModel.undercommittee + '/' + objModel.supermeeting);
                }
                dispatch({ type: types.ADD_AGENDAITEM_RESET });
            })
            .catch(function (err) {
                // console.log("addAgendaItemDetails action err", err)
                dispatch({ type: types.ADD_AGENDAITEM_REQUEST_ERROR });
            });
    }
}

export function updateAgendaItemDetails(objModel) {
    // console.log("updateAgendaItemDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_AGENDAITEM_REQUEST });
        agendaitemdetailsApi.updateAgendaItem(objModel)
            .then(function (response) {
                // console.log("updateAgendaItemDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_AGENDAITEM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/agenda/agenda-item-list/' + objModel.undercommittee + '/' + objModel.supermeeting);
                }
            })
            .catch(function (err) {
                // console.log("updateAgendaItemDetails action err", err)
                dispatch({ type: types.ADD_AGENDAITEM_REQUEST_ERROR });
            });
    }
}

export function updateNotes(objModel, committee_id, smeetingId) {
    // console.log("updateAgendaItemDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_AGENDAITEM_REQUEST });
        agendaitemdetailsApi.updateNotes(objModel)
            .then(function (response) {
                // console.log("updateAgendaItemDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_AGENDAITEM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/agenda/agenda-item-list/' + committee_id + '/' + smeetingId);
                }
            })
            .catch(function (err) {
                // console.log("updateAgendaItemDetails action err", err)
                dispatch({ type: types.ADD_AGENDAITEM_REQUEST_ERROR });
            });
    }
}

export function updateFileDetails(id, committee_id, objModel) {
    // console.log("updateFileDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.UPDATE_FILE_REQUEST });
        agendaitemdetailsApi.updateFile(id, objModel)
            .then(function (response) {
                // console.log("updateFileDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.UPDATE_FILE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    // history.push('/agenda/add-agenda-item/' + id + '/' + committee_id);
                }
            })
            .catch(function (err) {
                // console.log("updateFileDetails action err", err)
                dispatch({ type: types.UPDATE_FILE_REQUEST_ERROR });
            });
    }
}

export function deleteFileDetails(agendaid, objModel) {
    // console.log("updateAgendaItemDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_AGENDAITEM_REQUEST });
        agendaitemdetailsApi.deleteFile(objModel)
            .then(function (response) {
                // console.log("updateAgendaItemDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_AGENDAITEM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    // history.push('/agenda/add-agenda-item/' + agendaid);
                }
            })
            .catch(function (err) {
                // console.log("updateAgendaItemDetails action err", err)
                dispatch({ type: types.ADD_AGENDAITEM_REQUEST_ERROR });
            });
    }
}

export function deleteAgendaItemDetails(objModel, committee_id, smeetingId) {
    // console.log("updateAgendaItemDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_AGENDAITEM_REQUEST });
        agendaitemdetailsApi.deleteAgendaItem(objModel)
            .then(function (response) {
                // console.log("updateAgendaItemDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_AGENDAITEM_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    history.push('/agenda/agenda-item-list/' + committee_id + '/' + smeetingId);
                }
            })
            .catch(function (err) {
                // console.log("updateAgendaItemDetails action err", err)
                dispatch({ type: types.ADD_AGENDAITEM_REQUEST_ERROR });
            });
    }
}

export function updateFileOrder(file_id, order_number, oldIndex, meeting_id) {
    // console.log("rejectUser action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_AGENDAITEM_REQUEST });
        agendaitemdetailsApi.updateFileOrder(file_id, order_number, oldIndex, meeting_id)
            .then(function (response) {
                // console.log("rejectUser action succ", response)
                if (response.status == 200) {
                    // getUserDetailsList();
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: response.data });
                    // history.push('/user/checker-pending-approval');
                }
                dispatch({ type: types.ADD_AGENDAITEM_REQUEST_COMPLETED });
            })
            .catch(function (err) {
                // console.log("rejectUser action err", err)
                dispatch({ type: types.ADD_AGENDAITEM_REQUEST_ERROR });
            });
    }
}


// WEBPACK FOOTER //
// ./actions/agendaitemdetails.js